import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["data-testid"];
const _hoisted_2 = ["role"];
const _hoisted_3 = ["aria-label"];
import { computed } from "vue";
import { TextLink } from "@eudonet/opal";
import AdvancedFilterLibraryItem from "./AdvancedFilterLibraryItem.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdvancedFilterLibraryList',
    props: {
        items: {},
        selectedId: {},
        emptyState: {},
        tooltipTextById: {}
    },
    emits: ["select", "request-tooltip", "create", "edit", "rename", "delete", "manage-access"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const emptyMessageKey = computed(() => {
            switch (props.emptyState) {
                case "loading":
                    return "advancedFilterLibrary.empty.loading";
                case "error":
                    return "advancedFilterLibrary.empty.error";
                case "no-results":
                    return "advancedFilterLibrary.search.noResults";
                case "personal-empty":
                    return "advancedFilterLibrary.empty.personal";
                case "shared-empty":
                    return "advancedFilterLibrary.empty.shared";
                case "eudonet-empty":
                    return "advancedFilterLibrary.empty.eudonet";
                default:
                    return "";
            }
        });
        const emptyIcon = computed(() => {
            switch (props.emptyState) {
                case "loading":
                    return "ri-loader-4-line";
                case "error":
                    return "ri-error-warning-line";
                default:
                    return "ri-filter-3-line";
            }
        });
        // Create CTA only when the user's own tab is empty (not for loading / error / no-results / shared / eudonet).
        const showCreateCta = computed(() => props.emptyState === "personal-empty");
        return (_ctx, _cache) => {
            return (props.emptyState)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    "data-testid": `library-state-${props.emptyState}`,
                    class: "flex flex-1 flex-col items-center justify-center gap-3 py-10 text-center"
                }, [
                    _createElementVNode("i", {
                        class: _normalizeClass([emptyIcon.value, 'text-2xl text-(--colors-text-body-subtle)', { 'animate-spin': props.emptyState === 'loading' }]),
                        "aria-hidden": "true"
                    }, null, 2 /* CLASS */),
                    _createElementVNode("p", {
                        class: "text-sm text-(--colors-text-body-subtle)",
                        role: props.emptyState === 'error' ? 'alert' : undefined
                    }, _toDisplayString(_ctx.$t(emptyMessageKey.value)), 9 /* TEXT, PROPS */, _hoisted_2),
                    (showCreateCta.value)
                        ? (_openBlock(), _createBlock(_unref(TextLink), {
                            key: 0,
                            "data-testid": "empty-create-cta",
                            "icon-left": "ri-add-line",
                            onClick: _cache[0] || (_cache[0] = ($event) => (emit('create')))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("advancedFilterLibrary.footer.create")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_1))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    role: "listbox",
                    class: "flex flex-col gap-[6px]",
                    "aria-label": _ctx.$t('advancedFilterLibrary.title')
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
                        return (_openBlock(), _createBlock(AdvancedFilterLibraryItem, {
                            key: item.id,
                            item: item,
                            selected: item.id === props.selectedId,
                            "tooltip-text": props.tooltipTextById[item.id] ?? _ctx.$t('advancedFilterLibrary.tooltip.loading'),
                            onSelect: ($event) => (emit('select', item.id)),
                            onRequestTooltip: ($event) => (emit('request-tooltip', item.id)),
                            onEdit: ($event) => (emit('edit', item.id)),
                            onRename: ($event) => (emit('rename', item.id, item.name)),
                            onDelete: ($event) => (emit('delete', item.id, item.name)),
                            onManageAccess: ($event) => (emit('manage-access', item.id, item.name))
                        }, null, 8 /* PROPS */, ["item", "selected", "tooltip-text", "onSelect", "onRequestTooltip", "onEdit", "onRename", "onDelete", "onManageAccess"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_3));
        };
    }
});
